module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM10 26H6v-4h4v4zm0-6H6v-4h4v4zm6 6h-4v-4h4v4zm0-6h-4v-4h4v4zm6 6h-4v-4h4v4zm0-6h-4v-4h4v4zm2-10H4V4h20v6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/calculator-1.js
// module id = 1032
// module chunks = 14